// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__FBSnS","root":"styles_root__ctMdf","element":"styles_element__cXMZI","full":"styles_full__vwI6Y","gridItem":"styles_gridItem__Fpb9t"};